import { ThemeProvider } from 'styled-components'
import { I18nextProvider } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'

import GlobalStyle from '~assets/styles/global'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import { Outlet } from 'react-router-dom'
import { Signature } from '~containers'
import { ToastProvider } from '~context/ToastContextProvider'
import i18nSetup from '../i18n'

function UserSignatue(): JSX.Element {
  const fallbackRender = (): JSX.Element => null

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary fallbackRender={fallbackRender}>
        <GlobalStyle />
        <Outlet />
        <ToastProvider>
          <I18nextProvider i18n={i18nSetup}>
            <>
              <div className="portal-user-signature" />
              <Signature />
            </>
          </I18nextProvider>
        </ToastProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default UserSignatue
